import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const AUDSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M15.3894 3C15.8383 3 16.2029 3.29381 16.2029 3.65625V4.65234C17.0127 4.73001 17.6764 4.92442 18.2126 5.20605C18.9357 5.5859 19.3648 6.093 19.615 6.57324C19.789 6.9073 19.5951 7.29207 19.1814 7.43262C18.7676 7.57311 18.291 7.41607 18.1169 7.08203C17.9674 6.79499 17.7262 6.51589 17.3259 6.30566C17.0611 6.16663 16.6997 6.04337 16.2029 5.97754V9.38477C16.2052 9.38534 16.2074 9.38615 16.2097 9.38672L16.2732 9.40137C16.8677 9.53879 17.7436 9.74126 18.4773 10.1299C19.2868 10.5587 19.9718 11.2409 19.9997 12.2939V12.3086C19.9982 13.3041 19.4609 14.1053 18.5583 14.6367C17.905 15.0214 17.0909 15.2487 16.2029 15.3389V16.3438C16.2029 16.7062 15.8383 17 15.3894 17C14.9407 16.9999 14.5769 16.7061 14.5769 16.3438V15.3555C12.0365 15.1435 11.0728 13.8048 10.8347 13.3037C10.6739 12.9653 10.8834 12.5859 11.3025 12.4561C11.7215 12.3265 12.1915 12.4957 12.3523 12.834C12.433 13.0035 12.9309 13.8413 14.5769 14.0322V10.3984C14.1478 10.2987 13.6632 10.1692 13.2283 10.0059C12.1988 9.61931 10.9823 8.89117 10.9831 7.56543C10.9566 6.07842 12.407 4.88487 14.5769 4.65527V3.65625C14.5769 3.2939 14.9407 3.00015 15.3894 3ZM4.47533 4.03125C4.93231 4.03134 5.54814 4.24505 5.79564 4.83984L5.84056 4.96387L7.69212 11.0723L8.92259 15.1309L8.94798 15.2598C8.97566 15.5606 8.7894 15.8503 8.489 15.9414C8.18852 16.0324 7.87322 15.8946 7.72923 15.6289L7.67845 15.5078L6.58763 11.9102H2.36302L1.2722 15.5078C1.16793 15.8509 0.804913 16.0452 0.461656 15.9414C0.118323 15.8373 -0.0756515 15.4742 0.0280624 15.1309L1.25853 11.0723L3.11009 4.96387L3.15502 4.83984C3.40257 4.24497 4.01833 4.03125 4.47533 4.03125ZM16.2029 14.0127C16.7835 13.9339 17.2545 13.7798 17.6003 13.5762C18.0837 13.2916 18.3704 12.8855 18.3738 12.3145C18.3573 11.7965 18.0579 11.4778 17.5857 11.2275C17.1858 11.0157 16.6996 10.8748 16.2029 10.7529V14.0127ZM4.47533 5.33203C4.41398 5.33203 4.36911 5.34658 4.34837 5.3584L2.75658 10.6104H6.19408L4.6013 5.3584C4.58034 5.34665 4.53591 5.33208 4.47533 5.33203ZM14.5769 5.98047C13.1843 6.18188 12.5962 6.92344 12.6091 7.5498V7.5625C12.6071 8.10288 13.0614 8.49538 13.9138 8.81543C14.1392 8.90006 14.3613 8.96976 14.5769 9.02832V5.98047Z"
        fill="#888888"
      />
    </svg>
  );
};
